import React, { useState } from 'react';
import { Play, Volume2 } from 'lucide-react';

const VideoTestimonialsSection = () => {
  const [playingVideo, setPlayingVideo] = useState(null);

  const videos = [
    {
      id: 3,
      url: "https://customer-assets.emergentagent.com/job_gyano-kids/artifacts/uyac8v1a_video_20260321_100427.mp4",
      thumbnail: "/WhatsApp Image 2026-04-15 at 1.39.45 PM.jpeg",
      title: "Parent Testimonial 1"
    },
    {
      id: 4,
      url: "https://customer-assets.emergentagent.com/job_gyano-kids/artifacts/l2df7ovf_video_20260321_111637.mp4",
      thumbnail: "/WhatsApp Image 2026-04-15 at 1.45.19 PM.jpeg",
      title: "Parent Testimonial 2"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 mb-4">
            <Volume2 className="w-6 h-6 text-blue-600" />
            <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">Video Testimonials</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Hear From Our <span className="text-blue-600">Parents</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Real stories from parents who trust us with their children's education
          </p>
          <div className="w-24 h-1 bg-yellow-400 mx-auto rounded-full mt-4" />
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {videos.map((video) => (
            <div 
              key={video.id}
              className="group relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              {playingVideo === video.id ? (
                <div className="aspect-[9/16]">
                  <video
                    controls
                    autoPlay
                    className="w-full h-full object-contain object-center"
                    onEnded={() => setPlayingVideo(null)}
                  >
                    <source src={video.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <div 
                  className="relative aspect-[9/16] cursor-pointer"
                  onClick={() => setPlayingVideo(video.id)}
                >
                  {/* Thumbnail */}
                  <img 
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-contain"
                  />
                  
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 via-blue-900/20 to-transparent group-hover:from-blue-900/70 transition-all duration-300" />
                  
                  {/* Play Button */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-20 h-20 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-2xl group-hover:scale-110 group-hover:bg-white transition-all duration-300">
                      <Play className="w-10 h-10 text-blue-600 ml-1" fill="currentColor" />
                    </div>
                  </div>

                  {/* Title Badge */}
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="bg-white/95 backdrop-blur-sm px-4 py-2 rounded-xl shadow-lg">
                      <p className="text-gray-800 font-semibold text-sm flex items-center">
                        <Volume2 className="w-4 h-4 mr-2 text-blue-600" />
                        {video.title}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="text-center mt-12">
          <p className="text-gray-600 text-lg">
            Join hundreds of happy parents who chose Gyanodeepti for their children
          </p>
        </div>
      </div>
    </section>
  );
};

export default VideoTestimonialsSection;
